import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../utils/AuthContext";
import { createEnquiry } from "../api/Api";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from "../Assets/kalam_kids_best_kindergarten_logo.png";
import Loader from "../Loader/Loader";
import { MdCheckCircle } from "react-icons/md";
import BranchSelectionModal from "../component/BranchSelectionModal";
import { generateAcademicYears, getAcademicYear } from "../utils/academicYearUtils";

const MarketingEnquiry = () => {
  const navigate = useNavigate();
  const { academicYear } = useContext(AuthContext);
  const [showBranchSelectionModal, setShowBranchSelectionModal] = useState(true);
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const [formData, setFormData] = useState({
    studentName: "",
    gender: "",
    dob: "",
    fatherName: "",
    fatherMobile: "",
    fatherEmail: "",
    motherName: "",
    motherMobile: "",
    motherEmail: "",
    area: "",
    city: "",
    state: "",
    age: "",
    plotNo: "",
    street: "",
    landmark: "",
    academicYear: academicYear || getAcademicYear(new Date()),
    admissionFor: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  const handleBranchSelected = (branchId) => {
    setSelectedBranchId(branchId);
    setShowBranchSelectionModal(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log(`Input changed: ${name}, Value: ${value}`); // Debugging line
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "dob" && value) {
      const dob = new Date(value);
      const currentDate = new Date();
      let calculatedAge = currentDate.getFullYear() - dob.getFullYear();
      const monthDiff = currentDate.getMonth() - dob.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && currentDate.getDate() < dob.getDate())) {
        calculatedAge--;
      }
      setFormData((prevData) => ({
        ...prevData,
        age: calculatedAge,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!formData.studentName || !formData.fatherName || !formData.fatherMobile || !formData.gender || !formData.dob || !selectedBranchId || !formData.academicYear || !formData.admissionFor) {
      toast.error("Please fill in all required fields (Student Name, Gender, DOB, Father Name, Father Mobile, Academic Year, Enquiry For) and select a Branch.");
      setIsSubmitting(false);
      return;
    }

    console.log("Selected Branch ID on submit:", selectedBranchId); // Debugging line

    try {
      const response = await createEnquiry({ ...formData, branch: selectedBranchId });
if (response.success) {
  setShowThankYou(true);

  setFormData({
    studentName: "",
    gender: "",
    dob: "",
    fatherName: "",
    fatherMobile: "",
    fatherEmail: "",
    motherName: "",
    motherMobile: "",
    motherEmail: "",
    area: "",
    city: "",
    state: "",
    age: "",
    plotNo: "",
    street: "",
    landmark: "",
    academicYear:
      academicYear || getAcademicYear(new Date()),
    admissionFor: "",
  });

  // AUTO CLOSE + REDIRECT
  setTimeout(() => {
    setShowThankYou(false);

    navigate("/");
  }, 3000);
}else {
        toast.error(response.message || "Failed to submit the form.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Failed to submit the form. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const options = ["Day Care", "Play Group", "Pre KG", "LKG", "UKG"];
  const academicYears = generateAcademicYears();

  return (
    <>
      {showBranchSelectionModal || !selectedBranchId ? (
        <BranchSelectionModal onSelectBranch={handleBranchSelected} />
      ) : (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center py-6 md:py-10 px-3 sm:px-4">
          <ToastContainer />
          <div className="bg-white p-4 sm:p-6 md:p-10 rounded-xl md:rounded-2xl shadow-xl w-full max-w-5xl">
            <div className="flex flex-col lg:flex-row items-start lg:items-center border-b border-[#16bab1]">
              <img
                src={logo}
                alt="Logo"
                className="h-56 w-72 object-contain mx-auto lg:mx-0"
              />
              <div className="flex flex-col w-full lg:ml-8">
                <h1 className="text-[#16bab1]xl text-[#16bab1] font-semibold mb-4 text-[#16bab1]enter lg:text-left">
                  Enquiry Form
                </h1>
                <div className="flex flex-col lg:flex-row lg:space-x-8">


                  <div className="mt-4 mb-3 lg:mt-2 w-full lg:w-auto">
                    <label
                      htmlFor="admission"
                      className="block text-sm font-medium text-gray-700"
                    >
                      Enquiry For:
                    </label>
                    <div className="flex flex-wrap gap-4 mt-2">
                      {options.map((option) => (
                        <div
                          key={option}
                          onClick={() =>
                            setFormData((prev) => ({ ...prev, admissionFor: option }))
                          }
                          className={`cursor-pointer capitalize px-4 py-1 rounded-full border ${formData.admissionFor === option
                            ? "bg-[#16bab1] text-white"
                            : "bg-white text-gray-700 border-gray-300"
                            }`}
                        >
                          {option}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              <div className="flex flex-col">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Student Name *</label>
                <input
                  type="text"
                  name="studentName"
                  placeholder="Full Name"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.studentName}
                  required
                />
              </div>

              <div className="flex flex-col">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Gender</label>
                <select
                  name="gender"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.gender}
                >
                  <option value="">Select Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="flex flex-col relative">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Date of Birth</label>
                <input
                  type="date"
                  name="dob"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.dob}
                  required
                />                {formData.age !== "" && (
                  <div className="mt-1 text-xs sm:text-sm text-gray-600">
                    Calculated Age: <span className="font-bold">{formData.age}</span>
                  </div>
                )}
              </div>

              <div className="flex flex-col">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Father's Name *</label>
                <input
                  type="text"
                  name="fatherName"
                  placeholder="Father's Name"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.fatherName}
                  required
                />
              </div>

              <div className="flex flex-col">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Father's Mobile *</label>
                <input
                  type="tel"
                  name="fatherMobile"
                  placeholder="10-digit Mobile"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.fatherMobile}
                  required
                />
              </div>

              <div className="flex flex-col">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Father's Email</label>
                <input
                  type="email"
                  name="fatherEmail"
                  placeholder="Email ID"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.fatherEmail}
                />
              </div>

              <div className="flex flex-col">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Mother's Name</label>
                <input
                  type="text"
                  name="motherName"
                  placeholder="Mother's Name"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.motherName}
                />
              </div>

              <div className="flex flex-col">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Mother's Mobile</label>
                <input
                  type="tel"
                  name="motherMobile"
                  placeholder="Mobile Number"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.motherMobile}
                />
              </div>

              <div className="flex flex-col">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Mother's Email</label>
                <input
                  type="email"
                  name="motherEmail"
                  placeholder="Email ID"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.motherEmail}
                />
              </div>

              <div className="flex flex-col">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Plot No/Name</label>
                <input
                  type="text"
                  name="plotNo"
                  placeholder="Plot No"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.plotNo}
                />
              </div>

              <div className="flex flex-col">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Street</label>
                <input
                  type="text"
                  name="street"
                  placeholder="Street Name"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.street}
                />
              </div>

              <div className="flex flex-col">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Landmark</label>
                <input
                  type="text"
                  name="landmark"
                  placeholder="Near by..."
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.landmark}
                />
              </div>

              <div className="flex flex-col">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Area</label>
                <input
                  type="text"
                  name="area"
                  placeholder="Area"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.area}
                />
              </div>

              <div className="flex flex-col">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">City</label>
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.city}
                />
              </div>

              <div className="flex flex-col">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">State</label>
                <input
                  type="text"
                  name="state"
                  placeholder="State"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.state}
                />
              </div>
              <div className="flex flex-col">
                <label className="text-xs sm:text-sm font-semibold text-gray-700 mb-1">Academic Year *</label>
                <select
                  name="academicYear"
                  className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#16bab1] text-sm sm:text-base"
                  onChange={handleInputChange}
                  value={formData.academicYear}
                  required
                >
                  <option value="">Select Academic Year</option>
                  {academicYears.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </form>

            <div className="mt-8 md:mt-10 flex flex-col items-center">
              <button
                type="submit"
                onClick={handleSubmit}
                disabled={isSubmitting}
                className="w-full sm:w-64 py-3.5 sm:py-4 bg-[#16bab1] text-white text-base sm:text-lg font-bold rounded-xl shadow-lg hover:bg-[#129a93] transition-all disabled:opacity-50 flex justify-center items-center"
              >
                {isSubmitting ? <Loader /> : "Submit Enquiry"}
              </button>
              <p className="mt-3 md:mt-4 text-gray-500 text-xs sm:text-sm italic">
                * Required fields
              </p>
            </div>
          </div>

          {showThankYou && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 p-4">
              <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-2xl w-full max-w-sm text-center">
                <MdCheckCircle className="text-green-500 mx-auto mb-4" size={64} />
                <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">Thank You!</h2>
                <p className="text-sm sm:text-base text-gray-600 mb-6">Your enquiry has been submitted successfully. We will get back to you soon.</p>
                <button
                  onClick={() => setShowThankYou(false)}
                  className="w-full sm:w-auto px-8 py-2.5 bg-[#16bab1] text-white font-bold rounded-lg hover:bg-[#129a93]"
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default MarketingEnquiry;
